module.exports = __webpack_public_path__ + "img/115027.8aa59914.png";